






















































































































import moment from 'moment'
import { dateFromIsoString } from 'plankton'
import { mapGetters, mapActions } from 'vuex'
import Card from '@/components/Card.vue'
import PaymentDocumentsStep from './PaymentDocumentsStep.vue'
import { getAppTenant, TENANT } from '@/environment-detection'
import RenderWithTheme, { isPosteTheme } from '@/components/RenderWithTheme.vue'

export default {
  components: { PaymentDocumentsStep, Card, RenderWithTheme },
  props: {
    transportId: { type: Number, required: true },
    paymentDate: { type: Date, default: null }
  },
  computed: {
    ...mapGetters(['podProcessStatus', 'podDocuments']),
    isPosteTheme() {
      return isPosteTheme
    },
    step() {
      switch (this.podProcessStatus) {
        case 'STEP_ONE':
          return 1
        case 'STEP_TWO':
          return 2
        case 'STEP_THREE':
          return 3
        case 'STEP_FOUR':
          return this.isPosteTheme ? 3 : 4 // Override step 3 for poste as per stackholder requirement
        default:
          return null
      }
    },
    allowFileUpload() {
      return this.podProcessStatus === 'STEP_ONE'
    },
    remainingDaysUntilPayment() {
      const paymentDateStartOfDay = moment(this.paymentDate).startOf('day')
      const nowStartOfDay = moment().startOf('day')
      return Math.max(paymentDateStartOfDay.diff(nowStartOfDay, 'days'), 0)
    },
    formattedPaymentDate() {
      return dateFromIsoString(this.paymentDate)
    },
    financeEmail() {
      switch (getAppTenant()) {
        case TENANT.SENNDER:
          return 'finance@sennder.com'
        case TENANT.POSTE:
          return 'finance@sennder.it'
        default:
          return 'finance@sennder.com'
      }
    }
  },
  created() {
    this.loadPodProcessStatus(this.transportId)
    this.loadPoDDocuments(this.transportId)
  },
  methods: {
    ...mapActions(['loadPodProcessStatus', 'loadPoDDocuments'])
  }
}
